export const environment = {
  mobileBreakpoint: '600px',
  production: true,
  teamAssetsUrl: 'https://realmadrid-static.geographica.gs',
  teamUrl: 'https://publish-p47754-e237306.adobeaemcloud.com/content/dam/common/statics/public-content/badge/basket',
  playerUrl: 'https://publish-p47754-e237306.adobeaemcloud.com/players/basket',
  carto: {
    tablePreffix: '',
    tableSuffix: '',
    baseUrl: 'https://${username}.carto.com',
    mapApiEndpoint: '/api/v1/map?config=${mapConfig}',
    sqlApiEndpoint: '/api/v2/sql?q=${query}',
    username: 'geographica-real',
  },
  // websocketURL: 'wss://api-realmadrid.geographica.gs/live'
  websocketURL: 'ws://35.195.68.147/live'
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts